<template>
  <article>
    <div class="filter mt-20">
      <div class="filter__item">
        <div class="filter__name">订单ID：</div>
        <el-input v-model="filters.soid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">用户ID：</div>
        <el-input v-model="filters.suid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">交易订单号：</div>
        <el-input v-model="filters.out_trade_no" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <el-select class="filter__input" size="mini" v-model="filters.status" filterable placeholder="请选择">
          <el-option :label="item.name" :value="item.status" v-for="(item, index) in statusList" :key="index"></el-option>
        </el-select>
      </div>
      <button class="blue-small-btn" @click="getList">搜索</button>
    </div>
    <el-table :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="mt-30" height="600">
      <el-table-column prop="oprid" label="ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="soid" label="订单ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="suid" label="用户ID" width="" align="center">
        <template slot-scope="scope">
          <div @dblclick="setFiltersValue('suid', scope.row.suid)">{{scope.row.nickname}}({{scope.row.suid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="orderid" label="订单号" width="" align="center">
      </el-table-column>
      <el-table-column prop="out_trade_no" label="交易订单号" width="" align="center">
      </el-table-column>
      <el-table-column prop="total_fee" label="支付金额" width="" align="center">
      </el-table-column>
      <el-table-column prop="status" label="状态" width="100" fixed="right" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 0">未支付</div>
          <div v-if="scope.row.status == 1">支付成功</div>
          <div v-if="scope.row.status == 2">支付失败</div>
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="电话号码" width="" align="center">
      </el-table-column>
      <el-table-column prop="name" label="姓名" width="" align="center">
      </el-table-column>
      <el-table-column prop="address" label="地址" width="" align="center">
      </el-table-column>
      <el-table-column prop="" label="创建时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
  </article>
</template>

<script>
import mixinList from '../../../mixins/list'
import util from '../../../script/util'
import {shopOrderPayLists} from '../../../api/api'
export default {
  name: 'shopOrderList',
  mixins: [mixinList],
  data () {
    return {
      filters: {
        p: 1,
        l: 20,
        total: 0,
        soid: '',
        suid: '',
        out_trade_no: '',
        status: -1
      },
      statusList: [
        {
          name: '所有',
          status: -1
        },
        {
          name: '未支付',
          status: 0
        },
        {
          name: '支付成功',
          status: 1
        },
        {
          name: '支付失败',
          status: 2
        }
      ],
      lists: [],
      listLoading: false,
      dialog: false
    }
  },
  methods: {
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    setFiltersValue (key, value) {
      if (this.filters[key] === '') {
        this.filters[key] = value
      } else {
        this.filters[key] = ''
      }
      this.getList()
    },
    changeStatus (index) {
      this.statusList.forEach(item => {
        item.status = 0
      })
      this.statusList[index].status = 1
      this.filters.status = this.statusList[index].value
      this.filters.p = 1
      this.getList()
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }
      if (filters.soid !== '') {
        params.soid = filters.soid
      }
      if (filters.suid !== '') {
        params.suid = filters.suid
      }
      if (filters.out_trade_no !== '') {
        params.out_trade_no = filters.out_trade_no
      }
      if (filters.status !== -1) {
        params.status = filters.status
      }
      this.listLoading = true
      shopOrderPayLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          data.d.lists.forEach((item) => {
            item.isChoose = ''
          })
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    }
  },
  mounted () {
    this.getList()
  },
  watch: {
    'filters.soid': 'getList',
    'filters.suid': 'getList',
    'filters.out_trade_no': 'getList',
    'filters.status': 'getList'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/shop/shopOrderPayList.vue